import React, { memo } from 'react';
import { t } from 'ttag';

function Favourites({ withText = false, isVisible = true }) {
  if (!isVisible) return null;

  return (
    <a
      href="/account/home/#/favorite/"
      className="flex items-center gap-x-2 p-3 text-black outline-none focus:outline-none"
      aria-label={t`Go to your favorites`}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="h-6 w-6 shrink-0"
      >
        <path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z" />
      </svg>
      {withText && <span className="text-base">{t`Favourites`}</span>}
    </a>
  );
}

export default memo(Favourites);
